import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import RecipeForm from "components/agro/recipes/RecipeForm";
import { updateRecipe } from "graphql/mutations";
import { getRecipe } from "graphql/queries";

const RecipeUpdateForm = ({ recipeId, onSuccess }) => {
  const [recipe, setRecipe] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        companyID,
        code,
        date,
        type,
        recipeDetails,
        inputId,
        availableInventoryQuantity,
        inventoryUnit,
        inputQuantityToUse,
        applicationUnit,
        preparationProcedure,
        performedById,
        status
      } = valuesParam;

      await API.graphql({
        query: updateRecipe.replaceAll("__typename", ""),
        variables: {
          input: {
            id: recipeId,
            name,
            companyID,
            code,
            date,
            type,
            recipeDetails,
            inputId,
            availableInventoryQuantity: Number(availableInventoryQuantity),
            inventoryUnit,
            inputQuantityToUse: Number(inputQuantityToUse),
            applicationUnit,
            preparationProcedure,
            performedById,
            status
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(strings.responses.errorUpdate);
      console.error(err);
    }
  }

  async function fetchRecipe(id) {
    try {
      const recipeData = await API.graphql(graphqlOperation(getRecipe, { id }));
      const recipeItem = recipeData.data.getRecipe;
      if (!recipeItem) {
        toast.error(strings.responses.errorFetch);
        return;
      }
      setRecipe({
        ...recipeItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchRecipe(recipeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recipeId]);

  if (!recipe) return <Loader />;

  return (
    <div>
      <RecipeForm onSubmit={onSubmit} type="update" initialValues={recipe} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    successUpdated: "Receta actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la receta",
      errorUpdate: "Error al actualizar receta",
    },
  },
});

export default RecipeUpdateForm;
